import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { SeoRouteJsonParams_seoRoute$key } from '__generated__/SeoRouteJsonParams_seoRoute.graphql';
import Box from '@mui/material/Box';

type Props = {
  seoRoute: SeoRouteJsonParams_seoRoute$key;
};

const SeoRouteJsonParams: FC<Props> = props => {
  const { jsonParams } = useFragment(
    graphql`
      fragment SeoRouteJsonParams_seoRoute on SeoRoute {
        jsonParams {
          name
          value
        }
      }
    `,
    props.seoRoute
  );

  return (
    <Box>
      {jsonParams?.map(({ name, value }, i) => (
        <Box key={i}>
          <strong>{name}: </strong>
          {value}
        </Box>
      ))}
    </Box>
  );
};

export default SeoRouteJsonParams;
